import { render, staticRenderFns } from "./image.vue?vue&type=template&id=0208d2af&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=0208d2af&prod&lang=scss&scoped=true&"
import style1 from "./image.vue?vue&type=style&index=1&id=0208d2af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208d2af",
  null
  
)

export default component.exports